export default "__VITE_ASSET__B$WXwtTE__"